"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayModeTemplate = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../components");
var DisplayModeTemplate = function (_a) {
    var disabled = _a.disabled, editOnFocus = _a.editOnFocus, onStart = _a.onStart, placeholder = _a.placeholder, value = _a.value, icon = _a.icon, displayModeIcon = _a.displayModeIcon;
    var onFocus = function () { return editOnFocus && onStart(); };
    // Prefer specific icon to general
    var iconDisplay = displayModeIcon || icon;
    return (React.createElement("div", { className: "w-100 gk-in-place-input-placeholder", onFocus: onFocus },
        React.createElement(components_1.GKButton, { className: !disabled && value !== undefined ? "btn-editable" : "", color: "link", disabled: disabled, onClick: onStart },
            React.createElement("div", { className: "gk-in-place-input-placeholder-container d-flex w-100 h-100" },
                value !== undefined ? (value) : (React.createElement(React.Fragment, null,
                    React.createElement(components_1.GKIcon, { name: components_1.GKIconName.Add }),
                    placeholder || "Add")),
                iconDisplay && React.createElement(components_1.GKIcon, { name: iconDisplay, className: "ml-auto" })))));
};
exports.DisplayModeTemplate = DisplayModeTemplate;
